import { Component, OnInit, Input } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Step } from './step';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  providers: [NgbCarouselConfig] ,
  styleUrls: ['./carousel.component.css']
})
export class CarouselComponent implements OnInit {
  lastrace : any;
  private _lastrace = new BehaviorSubject<any>('');
  private _adventure = new BehaviorSubject<any>('');

  @Input() 
  set data(value){
    this._lastrace.next(value);
  };

  @Input() 
  set adventure(value){
    this._adventure.next(value);
  };

  get data() {
    return this._lastrace.getValue();
  };

  get adventure() {
    return this._adventure.getValue();
  };

  constructor(config: NgbCarouselConfig) {
    // customize default values of carousels used by this component tree
    config.interval = 0;
    config.wrap = true;
    config.keyboard = true;
    config.pauseOnHover = true;
  }



  steps = [];



  ngOnInit(): void {

    this._lastrace.subscribe(x => {
      this.lastrace = this.data;
      
      if(this.data){
        this.steps.push(new Step(this.lastrace.idRace.name, this.lastrace.idRace.description, `assets/images/${this.lastrace.idRace.code}-min.jpeg`, this.lastrace.percentage.toFixed(0)));
        this.steps.push(new Step(this.lastrace.idCity.name, "", `assets/images/${this.lastrace.idCity.name}-min.jpeg`, 0));
      }

    });

  }

}
